<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left">
                <v-btn text color="warning" :to="{ name: 'hpcPlans' }" class="ma-0 mb-2"><v-icon left>arrow_back</v-icon> Plan #{{ planId }}</v-btn>

                <h1 class="grey--text lighten-3 mb-2">Plan #{{ planId }}</h1>

                <div class="mt-4" v-if="planErrors.any()" v-cloak>
                    <v-alert dismissible v-model="showPlanError" outlined transition="scale-transition" type="warning">{{ planErrors.errors }}</v-alert>
                </div>

                <v-overlay :absolute="true" :value="overlay" z-index="99" opacity="0.56" id="paymentsucess">
                    <v-card>
                        <v-card-text v-html="overlayText" class="white--text"></v-card-text>
                        <v-card-actions>
                            <v-btn small block dark :color="overlayColor" @click="overlay = false">Close <v-icon medium right>highlight_off</v-icon> </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-overlay>

                <div v-if="planLoaded && viewPlan" v-cloak>
                    <v-stepper v-model="planStep" vertical>
                         <v-stepper-step :editable="editablePanel" :complete="planStep > 1" step="1" :color="planStep > 1 ? 'success' : 'primary'">
                            Plan Summary
                        </v-stepper-step>

                        <v-stepper-content step="1">
                            <v-card color="grey lighten-5" class="mb-5 elevetation-6">
                                <div class="Ftable">
                                    <div class="Ftable__row Ftable__header">
                                        <div class="Ftable__item cols-2 text-left">Plan</div>
                                        <div class="Ftable__item text-right"></div>
                                        <div class="Ftable__item text-right">Price</div>
                                    </div>
                                    <div class="Ftable__row">
                                        <div class="Ftable__item cols-2 text-left">
                                            <span class="d-block pt-1">Plan: {{ planDetail.plan_name }}&nbsp;-&nbsp;Price: {{ planDetail.plan_price | currency }}</span>
                                            <span class="d-block pt-1 text-capitalize">Billing Cycle: {{ planDetail.plan_billing_cycle }}&nbsp;-&nbsp;Auto Renewal: {{ planDetail.plan_auto_renewal}}</span>
                                            <span class="d-block pt-1 text-capitalize" v-if="!planDetail.plan_sliding_date">Expiry: {{ planDetail.plan_expiry_period }}</span>
                                            <span class="d-block pt-1" v-if="planDetail.plan_sliding_date">Start: {{ planDetail.plan_start_date }}&nbsp;-&nbsp;End: {{ planDetail.plan_end_date}}</span>
                                            <span class="d-block pt-1" v-if="planDetail.plan_excluded_date">Excluded Dates: {{ planDetail.plan_excluded_date }}</span>
                                        </div>
                                        <div class="Ftable__item text-right"></div>
                                        <div class="Ftable__item text-right">
                                            <span>{{ planDetail.plan_price | currency }}</span>
                                        </div>
                                    </div>
                                    <div class="Ftable__row">
                                        <div class="Ftable__item cols-2 no-border right-border top-border"></div>
                                        <div class="Ftable__item text-right">
                                            <span><strong>Subtotal</strong></span>
                                        </div>
                                        <div class="Ftable__item text-right">
                                            <span>{{ subTotal | currency("$") }}</span>
                                        </div>
                                    </div>
                                    <div class="Ftable__row">
                                        <div class="Ftable__item cols-2 no-border right-border bottom-border"></div>
                                        <div class="Ftable__item text-right">
                                            <span><strong>Tax</strong></span>
                                        </div>
                                        <div class="Ftable__item text-right">
                                            <span>{{ taxTotal | currency("$") }}</span>
                                        </div>
                                    </div>
                                    <div class="Ftable__row">
                                        <div class="Ftable__item cols-2 no-border right-border top-border"></div>
                                        <div class="Ftable__item text-right">
                                            <span><strong>Total</strong></span>
                                        </div>
                                        <div class="Ftable__item text-right">
                                            <span>{{ grandTotal | currency("$") }}</span>
                                        </div>
                                    </div>
                                </div>
                            </v-card>

                            <v-btn color="primary" @click="planStep = 2">Continue</v-btn>
                        </v-stepper-content>

                        <v-stepper-step :rules="[() => !errors.any('step2')]" :editable="editablePanel" :complete="planStep > 2" step="2" :color="planStep > 2 ? 'success' : 'primary'">
                            Terms & Conditions
                        </v-stepper-step>

                        <v-stepper-content step="2">
                            <v-form class="overwrite-inputs" data-vv-scope="step2" lazy-validation>
                                <v-card color="grey lighten-5" class="mb-5 elevetation-6 pa-5">
                                    I acknowledge and agree to the {{ appNameUrls.assoc_inc_short }} High Performance Terms and Conditions. I understand that the selected membership plan governs access and use of facilities, includes a minimum commitment period of 3 months, will automatically renew on a monthly basis thereafter, and requires 30 days’ written notice to cancel. I agree to comply (or ensure the attendee complies) with all rules and policies at all times. I give permission for myself / the attendee to be photographed, with images potentially used on the website and/or for promotional purposes. No personal information will be published with any image. I confirm that I have read and agree to the <a href="/hornets/high-performance/memberships/" target="_new">Contract Terms and Conditions</a> and <a href="/hornets/high-performance/memberships/" target="_new">Codes of Conduct</a>.<br>If the attendee is under 18 years of age, I confirm that I am their parent or legal guardian and give consent on their behalf.
                                    <v-checkbox
                                        class="mt-1 chk-label"
                                        v-model.lazy.trim="agreed"
                                        v-validate="'required:true'"
                                        :error="errors.has('agreed')"
                                        :error-messages="errors.collect('agreed')"
                                        :name="'agreed'"
                                        label="I agree to the Contract Terms and Conditions and Codes of Conduct.">
                                    </v-checkbox>
                                </v-card>

                                <v-btn color="primary" @click.native="submitStep('step2')" :disabled="errors.any('step2')">Continue</v-btn>
                                <div v-if="errors.any('step2')" class="red--text text--lighten-1">Please check the form above for errors.</div>
                            </v-form>

                        </v-stepper-content>

                        <v-stepper-step
                            :rules="[() => !paymentErrors.any()]"
                            :editable="editablePanel"
                            :complete="planStep > 3"
                            :step="3"
                            :color="planStep > 3 ? 'success' : 'primary'"
                        >
                            Make Online Payment
                            <small
                                v-if="paymentErrors.any() && !paymentErrors.has('error_response')"
                                class="caption font-weight-bold secondary--text"
                                v-html="getPaymentMessage"
                            ></small>
                            <small
                                v-if="paymentErrors.any() && paymentErrors.has('error_response')"
                                class="caption font-weight-bold secondary--text"
                                v-html="paymentErrors.get('error_response')"
                            ></small>
                        </v-stepper-step>

                        <v-stepper-content step="3">
                            <v-card color="grey lighten-5" class="mb-5 elevetation-6">
                                <v-card-text>
                                    <component :is="ftGateway" @submitted-pay="submitPay"></component>
                                </v-card-text>
                            </v-card>

                            <v-btn :loading="payLoading" :disabled="!validPaymentForm" color="primary" @click="payPlan" class="mr-2 text-left">
                                <v-icon left>local_atm</v-icon>{{ payHtml }}
                            </v-btn>
                            <v-btn @click="clearPay" color="warning" :disabled="payLoading" class="text-left">
                                <v-icon left>clear</v-icon>Clear
                            </v-btn>
                        </v-stepper-content>
                    </v-stepper>
                </div>

                <div class="justify-center align-center layout" v-if="!planLoaded || !viewPlan"><v-icon left medium>warning</v-icon> No Plan Data</div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from "./_store";

import { EventBus } from "@shared/EventBus.js";
import Eway from "@components/gateways/Eway.vue";

export default {
    name: "PlanPaymentModule",
    components: {
        eway: Eway,
    },
    props: {
        "plan-id": {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        return {
            planStep: 1,
            editablePanel: false,

            validPaymentForm: true,
            showPlanError: false,

            planDetail: {},
            planLoaded: false,
            viewPlan: true,

            agreed: false,
            dictionary: {
                messages: {
                    required: () => "This field is required",
                },
            },

            overlay: false,
            timeout: 1500,
            overlayText: "",
            overlayColor: "cyan darken-2",

            ftGateway: gtwPw,
        };
    },
    computed: {
        plans() {
            return this.$store.getters["plans/plans"];
        },
        plan() {
            return this.$store.getters["plans/planDetailById"](this.planId);
        },
        planErrors() {
            return this.$store.getters["plans/planErrors"];
        },
        paymentErrors() {
            return this.$store.getters["plans/paymentErrors"];
        },
        getPaymentMessage() {
            if (this.paymentErrors.any()) {
                if (this.paymentErrors.has("error_auth")) {
                    return this.paymentErrors.get("error_auth");
                }

                if (this.paymentErrors.has("error_paid")) {
                    return this.paymentErrors.get("error_paid");
                }

                if (this.paymentErrors.has("error_response")) {
                    return this.paymentErrors.get("error_response");
                }

                if (this.paymentErrors.has("error_validation")) {
                    return "Plan Data Invalid";
                }

                if (this.paymentErrors.has("error_payment")) {
                    return this.paymentErrors.get("error_payment");
                }

                return "Plan Invalid";
            }

            return "";
        },
        payLoading() {
            return this.$store.getters["plans/paymentStatus"] == "loading";
        },
        payHtml() {
            return "Save Credit Card";
        },
        user() {
            return this.$store.getters["user/getProfile"];
        },
        planCart() {
            return this.$store.getters["plans/planCart"];
        },
        subTotal() {
            return this.planCart.p_price;
        },
        taxTotal() {
            return this.subTotal / (taxRate + 1);
        },
        grandTotal() {
            return this.subTotal;
        },
    },
    watch: {
        plans(n, o) {
            let planId = this.planId;
            this.planDetail = _.find(n, function(plan) {
                return plan.plan_id == planId;
            });

            this.planLoaded = true;
            if (_.isEmpty(this.planDetail) && this.plan === undefined) {
                this.planLoaded = false;
                this.viewPlan = false;
            }
        },
        plan() {
            this.planDetail = this.plan;

            if (!_.isEmpty(this.planDetail)) {
                this.planLoaded = true;

                // let nameDetail = "Plan #" + this.planDetail.plan_id;
                // this.$store.dispatch("plans/updatePlanCart", { name: nameDetail, price: this.planDetail.plan_price });
            }
        },
    },
    methods: {
        clearPay() {
            this.alert = false;
            EventBus.$emit("clear-pay");
            this.$store.dispatch("plans/clearPaymentErrors");
        },
        payPlan: function() {
            if (this.grandTotal > 0) {
                EventBus.$emit("submit-pay");
            } else {
                this.submitPay();
            }
        },
        submitStep(scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this.planStep++;
                }
            });
        },
        submitPay: function(payload) {
            this.validPaymentForm = false;

            const plan = this.planId;
            const cardPayload = payload;

            this.$store
                .dispatch("plans/payPlan", {
                    plan: plan,
                    cardPayload: cardPayload,
                })
                .then(order => {
                    this.overlayText = "Your subscription has been successfully activated.";
                    this.overlay = true;
                    this.overlayColor = "primary";

                    const targetElement = document.getElementById('paymentsucess');
                    if (targetElement) {
                        targetElement.scrollIntoView({ behavior: 'smooth' }); // Smooth scrolling animation
                    }

                    setTimeout(() => {
                        // this.$store
                            // .dispatch("plans/plansRequest")
                            // .then(() => {
                                // this.$router.push({ name: "orderDetail", params: { order_id: order.o_id } });
                                this.$router.push({ name: "hpcClasses" });
                            // })
                            // .catch();
                    }, this.timeout);
                })
                .catch(err => {
                    this.validPaymentForm = true;
                    // console.log(err);

                    setTimeout(() => {
                        EventBus.$emit("clear-pay");
                    }, 500);
                });
        },
        resetPlan: function() {
            if (!_.isEmpty(this.plans)) {
                this.$store.dispatch("plans/updatePlans", this.plans);

                let planId = this.planId;
                this.planDetail = _.find(this.plans, function(plan) {
                    return plan.plan_id == planId;
                });

                if (!_.isEmpty(this.planDetail)) {
                    this.planLoaded = true;
                }
            }
        },
    },
    beforeCreate() {
        // this.$store.dispatch('user/userRequest');

        // if (_.isEmpty(this.$store.getters["plans/plans"])) {
            this.$store.dispatch("plans/plansRequest").then(() => {
                let nameDetail = "Plan #" + this.planDetail.plan_id;
                this.$store.dispatch("plans/updatePlanCart", { name: nameDetail, price: this.planDetail.plan_price });
            });
        // }
    },
    created() {
        this.resetPlan();
    },
    mounted() {
        this.$store.dispatch("plans/resetTotals");

        if (_.isEmpty(this.planDetail) && this.plan !== undefined) {
            this.planDetail = this.plan;
        }

        this.planLoaded = true;
    },
};
</script>

<style lang="scss">
[v-cloak] {
    display: none;
}
[v-cloak] > * {
    display: none;
}

.v-stepper__step.v-stepper__step--error .v-stepper__label,
.theme--light.v-stepper .v-stepper__step--active.v-stepper__step--error .v-stepper__label {
    text-shadow: none !important;
}

#paymentsucess.v-overlay.v-overlay--absolute.v-overlay--active.theme--dark {
    align-items: flex-start;
    padding-top: 60px;
}

.Ftable {
    $light-color: #ffffff;
    $header-color: #f8c689;
    $dark-color: #f2f2f2;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    /*border: 1px solid $dark-color;*/
    font-size: 1rem;
    padding: 0;
    margin: 0;
    line-height: 1.5;

    .Ftable__row {
        width: 100%;
        display: flex;

        &.Ftable__header {
            font-weight: bold;

            .Ftable__item {
                background: $header-color;
            }
        }

        .Ftable__item {
            flex: 1 1 25%;
            word-break: break-word;
            padding: 0.25em;
            border: 1px solid $light-color;
            background: $dark-color;

            &.cols-2 {
                flex: 1 1 50%;
            }

            &.no-border {
                border: 0px solid $light-color;
            }

            &.right-border {
                border-right: 1px solid $light-color;
            }

            &.top-border {
                border-top: 1px solid $light-color;
            }

            &.bottom-border {
                border-bottom: 1px solid $light-color;
            }
        }
    }
}
</style>
